import dayjs from "dayjs";
import { CalendarItemMap } from "../Calendar/CalendarItemMap.ts";
import { SlotDayAndHourKey } from "../Calendar/SlotDayAndHourKey.ts";
import {
  AvailableTeacherSlotDto,
  BookedClassRoomDto,
  BookedSlotGroup,
} from "./types.ts";

type GroupEntry = {
  key: SlotDayAndHourKey;
  group: BookedSlotGroup;
};

export function createBookedClassRoomsCalendarMap(
  classRooms: BookedClassRoomDto[],
  availableSlots: AvailableTeacherSlotDto[] = [],
): CalendarItemMap<BookedSlotGroup> {
  const grouped = new Map<string, GroupEntry>();

  function getOrCreateGroup({
    startUtc,
    endUtc,
    timezone,
  }: {
    startUtc: string;
    endUtc: string;
    timezone: string;
  }): BookedSlotGroup {
    const key = SlotDayAndHourKey.fromDate(dayjs(startUtc).tz(timezone));
    const mapKey = `${key.dateString}_${key.hourString}`;
    const existing = grouped.get(mapKey);
    if (existing) return existing.group;
    const group: BookedSlotGroup = {
      startUtc,
      endUtc,
      classRoomTimezone: timezone,
      classRooms: [],
      availableTeacherIds: [],
    };
    grouped.set(mapKey, { key, group });
    return group;
  }

  classRooms.forEach((c) => {
    getOrCreateGroup({
      startUtc: c.startUtc,
      endUtc: c.endUtc,
      timezone: c.classRoomTimezone,
    }).classRooms.push(c);
  });

  availableSlots.forEach((s) => {
    const group = getOrCreateGroup({
      startUtc: s.startUtc,
      endUtc: s.endUtc,
      timezone: s.slotTimezone,
    });
    group.availableTeacherIds = Array.from(
      new Set([...group.availableTeacherIds, ...s.teacherIds]),
    );
  });

  const map = new CalendarItemMap<BookedSlotGroup>();
  grouped.forEach(({ key, group }) => map.set(key, group));
  return map;
}
